(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamanda-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.mamanda-header__drawer-close');
    if (!button) return;
    const menu = button.closest('details.mamanda-header__mobile-menu');
    if (!menu) return;
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('details.mamanda-header__mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
